import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useState } from "react";

import HNSColors from "../../../../../../ui library/HNSColors";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function TimeAnswer({ name, label, value = "", onChange, placeholder }) {
  const [isFocused, setIsFocused] = useState(false);

  function getDateFromTimeString(timeStr) {
    if (!timeStr) {
      return null;
    }
    const [hours, minutes] = timeStr.split(":");
    const date = new Date();
    date.setHours(Number(hours) || 0, Number(minutes) || 0, 0, 0);
    return date;
  }

  const handleChange = (newDate) => {
    if (!newDate || isNaN(newDate.getTime?.())) {
      onChange(name, "");
      return;
    }
    const hours = String(newDate.getHours()).padStart(2, "0");
    const minutes = String(newDate.getMinutes()).padStart(2, "0");
    onChange(name, `${hours}:${minutes}`);
  };

  const CustomArrowIcon = (props) => (
    <KeyboardArrowDownIcon
      {...props}
      sx={{
        color: HNSColors.primary[500],
        transform: isFocused ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.2s ease-in-out",
      }}
    />
  );

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          className="w-full text-center"
          ampm
          format="hh:mm a"
          value={getDateFromTimeString(value)}
          onChange={handleChange}
          onOpen={() => setIsFocused(true)}
          onClose={() => setIsFocused(false)}
          slots={{
            openPickerIcon: CustomArrowIcon,
          }}
          slotProps={{
            textField: {
              onFocus: () => setIsFocused(true),
              onBlur: () => setIsFocused(false),
              sx: {
                ...sharedStyles.dateTimePicker.textField,
                "& input": { textTransform: "lowercase" },
              },
              placeholder,
            },
            openPickerButton: {
              disableRipple: true,
              sx: sharedStyles.dateTimePicker.openPickerButton,
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}

export default TimeAnswer;
